<template>
  <div>
    <div class="date-picker" @click="showRecordSelect = true">
      <div class="date-display">
        <span class="date-year">{{ selectedRecordTime | toYear }}</span>
        <div class="flex">
          <span>{{ selectedRecordTime | toDate }}</span>
          <span class="date-time">{{ selectedRecordTime | toTime }}</span>
        </div>
      </div>
      <span class="arrow"></span>
    </div>

    <rounded-card
      v-if="showRecordSelect"
      :head-text="$t('homePage.select_date')"
      height="80%"
      show-right-btn
      @set-close-status="
        showRecordSelect = false;
        activeIndex = selectIndex;
      "
    >
      <span class="sub-title"> {{ subTitle }} </span>
      <scroller class="w-full flex flex-col items-center gap-8 mt-8" :scrollToIndex="activeIndex">
        <div
          v-for="(r, index) in records"
          :key="r.tid"
          class="time-list"
          :class="{ active: index === activeIndex }"
          @click="select(index)"
        >
          <div class="w-4 flex items-center mr-6">
            <img
              v-if="index === activeIndex"
              class="circle"
              src="../../assets/common/group-471.svg"
            />
          </div>

          <div class="flex justify-between gap-2">
            <span> {{ r.created_at | toDate }} </span>
            <span class="gray w-10 text-right">{{ r.created_at | toTime }}</span>
          </div>

          <div class="w-10 ml-8">
            <span
              v-if="index === 0 || !isSameYear(r.created_at, records[index - 1].created_at)"
              class=""
              >{{ r.created_at | toYear }}</span
            >
          </div>
        </div>
      </scroller>

      <div class="w-full flex mt-auto mb-5 justify-around">
        <c-button class="my-3" @click="selectConfirm">
          <span>{{ $t('homePage.select') }}</span>
        </c-button>
      </div>
    </rounded-card>
  </div>
</template>

<script>
import i18n from '@/i18n';
import CButton from '@/components/common/CButton.vue';
import RoundedCard from '@/components/common/RoundedCard.vue';
import Scroller from '@/components/common/Scroller.vue';

export default {
  name: 'DatePicker',
  components: {
    CButton,
    RoundedCard,
    Scroller,
  },
  props: {
    records: Array,
    selectIndex: {
      type: Number,
      default: 0,
    },
    subTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showRecordSelect: false,
      activeIndex: 0,
    };
  },
  mounted() {
    this.activeIndex = this.selectIndex;
  },
  methods: {
    select(index) {
      this.activeIndex = index;
    },
    selectConfirm() {
      this.$emit('select', this.activeIndex);
      this.$emit('set-close-status');
      this.showRecordSelect = false;
    },
    isSameYear(date1, date2) {
      return date1.substring(0, 4) === date2.substring(0, 4);
    },
  },
  computed: {
    selectedRecordTime() {
      return this.records[this.activeIndex].created_at;
    },
  },
  filters: {
    toYear(value) {
      return new Date(value).getFullYear();
    },
    toDate(value) {
      const { locale } = i18n;
      const dateObj = new Date(value);
      return new Intl.DateTimeFormat(locale, { month: 'short', day: '2-digit' }).format(dateObj);
    },
    toTime(value) {
      const { locale } = i18n;
      const dateObj = new Date(value);
      return new Intl.DateTimeFormat(locale, { timeStyle: 'short', hour12: false }).format(dateObj);
    },
  },
  watch: {
    selectIndex(nv) {
      this.activeIndex = nv;
    },
  },
};
</script>

<style scoped>
.date-year {
  font-size: 10px;
}

.date-time {
  margin-left: 5px;
  color: #8c8c8c;
}

.date-picker {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(191, 191, 191, 0.15);
  border-radius: 4px;
  width: 158px;
  height: 44px;
  padding: 0.5rem;
}

.date-display {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.5px;
}

.arrow {
  width: 30px;
  height: 30px;
  background: url('../../assets/common/icon-expand.svg') center no-repeat;
}

.time-list {
  display: flex;
  font-size: 14px;
}

.sub-title {
  position: absolute;
  margin-top: 3.5rem;
  font-size: 14px;
}

.active {
  background: var(--brand-gradient-vertical);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-nowrap {
  white-space: nowrap;
}

.gray {
  color: #8c8c8c;
}
</style>
